import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoDatePickerMixin from './KendoDatePickerMixin'

export default {
    name: 'kendo-datepicker',
    mixins: [ KendoDatePickerMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('input',{
            props: {
                value: this.value
            }
        })
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDatePicker/index.js